<template>

  <Transition name="fade">
    <ItsmModal v-if="isModalOpen != 0" :isModalOpen="isModalOpen" :toggleModal="toggleModal" :selectedItsm="selectedItsm"/>
  </Transition>

  <div class="py-4 container-fluid no-drag">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="row">
              <div class="col-md-4">
                <i class="ni ni-settings onmaum-text-itsm text-sm opacity-10"></i><span class="mb-0" style="font-size: 1rem; line-height: 1.625; font-weight: 600; margin-top: 0; color: #344767"> 사이트 수정 요청</span>
              </div>
              <div class="col-md-6">

              </div>
              <div class="col-md-2 text-center">
                <button class="btn btn-onmaum btn-sm ms-auto" @click="toggleModal(1)">요청하기</button>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0 onmaum-overflow-y onmaum-overflow-type02 onmaum-h-70-v">
              <table class="table table-striped text-center align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7">번호</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7">제목</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7">요청자</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7">요청일</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7">처리여부</th>
                    <th class="text-secondary text-sm font-weight-bolder opacity-7">확인일</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(itsm, i) in itsmInfo" :key="i">
                    <td>
                      <p class="text-sm font-weight-bold mb-0">{{ i + 1 }}</p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-sm text-onmaum-hover font-weight-bold mb-0" @click="selectItsm(itsm);">{{ itsm.title }}</p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-sm font-weight-bold mb-0">{{ itsm.req_user }}</p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-sm font-weight-bold mb-0">{{ itsm.insert_date }}</p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge bg-info" v-if="itsm.complete == 0">확인전</span>
                      <span class="badge bg-success" v-if="itsm.complete == 1">완료</span>
                      <span class="badge bg-secondary" v-if="itsm.complete == 2">처리중</span>
                      <span class="badge bg-warning" v-if="itsm.complete == 3">보류</span>
                      <span class="badge bg-onmaum" v-if="itsm.complete == 4">요청자 확인 요망</span>
                      <span class="badge bg-danger" v-if="itsm.complete == 5">불가</span>
                      <span class="badge bg-info" v-if="itsm.complete == 6">요청 변경</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-sm font-weight-bold mb-0">{{ itsm.complete_date }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItsmModal from '../components/ItsmModal.vue'

export default {
    name: 'itsm-board',
    data() {
      return {
        isModalOpen: 0,
        selectedItsm: {},
      }
    },
    components:{
      ItsmModal
    },
    methods:{
      toggleModal(id){
        this.isModalOpen = id;
      },
      selectItsm(obj){
        this.selectedItsm = obj;
        this.isModalOpen = 2;
      }
    },
    computed: {
      itsmInfo(){
        return this.$store.state.common.itsmInfo;
      }
    },
    mounted() {
      //관리자 및 플래너만 이 페이지에 접근 가능
      if(this.$store.state.login.userType == '기타사용자'){
        this.$router.push('/');
      }

      //고객 정보 가져오기
      this.$store.dispatch('getItsmInfo');
    },
}
</script>

<style>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
</style>